import letterChart from '../../../assets/img/visualacuity.png';
import visualField from '../../../assets/img/visualfield.png';
import clockDial from '../../../assets/img/astigmatism-clock.jpg';
import { ishiharaPlateImage } from '../../../helpers/ishihara';

// Picker tile artwork (Figma C6): the letter chart, the visual field dot grid, the refraction
// clock dial and an Ishihara plate (Colour Vision). Used when a category has no thumbnail_url of its own (local/staging data has "--").

export const examArtFor = (category) => {
  const k = `${category?.key || ''} ${category?.title || ''}`.toLowerCase();
  if (k.includes('field')) return visualField;
  if (k.includes('refraction')) return clockDial;
  if (k.includes('colour') || k.includes('color') || k.includes('ishihara')) return ishiharaPlateImage('02');
  return letterChart;
};

/** Artwork for a picker category (by category key, falling back to the title). */
export const ExamArt = ({ category }) => <img src={examArtFor(category)} alt='' draggable={false} />;

export default ExamArt;
